// ---------------------------------------------------------------------------
// Rótulos do breadcrumb por link-base (sem lang, minúsculo) do menu antigo.
//
// Cada entrada: { labelId } (chave i18n) OU { label } (texto fixo, p/ itens sem i18n no menu),
// e opcionalmente { parentLabelId } / { parentLabel } (o grupo-pai). Folhas-raiz não têm pai.
//
// Reusa as MESMAS chaves i18n do menu (mesma fonte de tradução) e as MESMAS bases de rota do
// matcher/aliases — então o breadcrumb resolve exatamente o mesmo item ativo que o menu marca.
// Mantido isolado (não acopla ao header-menu de 3718 linhas nem ao store).
// ---------------------------------------------------------------------------

export const MENU_BREADCRUMB = {
  // Folhas-raiz (Home / <item>)
  '/agent-workspace': { labelId: 'menu.agent.workspace' },
  '/calleds': { labelId: 'called.header' },
  '/new-calleds': { labelId: 'called.header' },
  '/kanban': { labelId: 'menu.kanban' },
  '/announcement': { labelId: 'menu.noticeboard' },
  '/calendar': { labelId: 'menu.calendar' },
  '/portal': { labelId: 'portal' },
  '/assignedcalleds': { labelId: 'called.assing' },
  '/called-rejection': { labelId: 'called.rejection' },
  '/finishedcalleds': { labelId: 'called.finished' },
  '/archived-calleds': { labelId: 'archived.calleds' },
  '/canceled-calleds': { labelId: 'canceled.calleds' },
  '/calledclassifications': { labelId: 'menu.called.classifications' },
  '/knowledgebases-client': { labelId: 'knowledge.center' },
  '/nps-search': { labelId: 'nps.search' },
  '/calledservicesettings': { labelId: 'menu.called.service.settings' },
  '/groups': { labelId: 'menu.groups' },

  // Dashboards
  '/dashboard': { labelId: 'menu.dashboards.operation', parentLabelId: 'dashboards' },
  '/dashboard-operation-new': { labelId: 'menu.dashboards.operation.new', parentLabelId: 'dashboards' },
  '/productivitydashboard': { labelId: 'menu.dashboards.productivity', parentLabelId: 'dashboards' },
  '/qualitydashboard': { labelId: 'menu.dashboards.quality', parentLabelId: 'dashboards' },

  // Relatórios
  '/organization-field-report': { labelId: 'organization.field.report', parentLabelId: 'reports' },
  '/calledreports': { labelId: 'called.report.header', parentLabelId: 'reports' },
  '/hours-report': { labelId: 'hours.reported', parentLabelId: 'reports' },
  '/organizations-categories-report': { labelId: 'organizations.categories.report', parentLabelId: 'reports' },
  '/agents-report': { labelId: 'menu.users-agents', parentLabelId: 'reports' },
  '/audit-report': { labelId: 'audit', parentLabelId: 'reports' },
  '/automation-execution-reports': { labelId: 'automations.execution', parentLabelId: 'reports' },
  '/automation-reports': { labelId: 'menu.automations', parentLabelId: 'reports' },
  '/calleds-organizations-report-archived': { labelId: 'calleds.organizations.report.archived', parentLabelId: 'reports' },
  '/calleds-organizations-report': { labelId: 'calleds.organizations.report', parentLabelId: 'reports' },
  '/calleds-organizations-synthetic-report': { labelId: 'calleds.organizations.synthetic.report', parentLabelId: 'reports' },
  '/calleds-organizations-report-general': { labelId: 'calleds.organizations.report.general', parentLabelId: 'reports' },
  '/calleds-organizations-breach-sla-report': { labelId: 'calleds.organizations.breach.sla.report', parentLabelId: 'reports' },
  '/calleds-origin-categories-report': { labelId: 'calleds-origin-categories', parentLabelId: 'reports' },
  '/materialreports': { labelId: 'material.report.header', parentLabelId: 'reports' },
  '/reopened-calleds-report': { labelId: 'reopened.calleds.report', parentLabelId: 'reports' },
  '/chatreports': { labelId: 'report.chat', parentLabelId: 'reports' },
  '/checklistreports': { labelId: 'checklist.report', parentLabelId: 'reports' },
  '/called-classification-reports': { labelId: 'calledClassification.report.header', parentLabelId: 'reports' },
  '/clicks-on-satisfaction-survey': { labelId: 'menu.2talk.clicks.on.satisfaction.survey', parentLabelId: 'reports' },
  '/costreports': { labelId: 'cost.report', parentLabelId: 'reports' },
  '/dashboardreports': { labelId: 'report.dashboard', parentLabelId: 'reports' },
  '/distribution-report': { labelId: 'distribution.report', parentLabelId: 'reports' },
  '/messaging-channel-log-report': { label: 'Relatório de Logs Mensageria', parentLabelId: 'reports' },
  '/called-closing-error-report': { label: 'Erros de Encerramento de Chamado', parentLabelId: 'reports' },
  '/sendmailreports': { labelId: 'sendmail.report.header', parentLabelId: 'reports' },
  '/usererrorreport': { label: 'Erros Reportados', parentLabelId: 'reports' },
  '/webhook-execution-report': { labelId: 'webhook.execution.report', parentLabelId: 'reports' },
  '/reportfcr': { labelId: 'report.fcr', parentLabelId: 'reports' },
  '/reports/feedback-article': { label: 'Feedback de Notícias', parentLabelId: 'reports' },
  '/macro-execution-report': { labelId: 'macro.execution.report', parentLabelId: 'reports' },
  '/break-work-report': { labelId: 'menu.report.break', parentLabelId: 'reports' },
  '/quantitative-calleds-report': { labelId: 'quantitative.calleds.report', parentLabelId: 'reports' },
  '/quantitative-chats-report': { labelId: 'quantitative.chats.report', parentLabelId: 'reports' },
  '/sendsmsreports': { labelId: 'sendsms.report.header', parentLabelId: 'reports' },
  '/techinicalteamusers-report': { labelId: 'menu.techinicalteamusers', parentLabelId: 'reports' },
  '/techinicalteam-report': { labelId: 'menu.techinicalteams', parentLabelId: 'reports' },
  '/users-report': { labelId: 'menu.users', parentLabelId: 'reports' },
  '/transition-status-report': { labelId: 'menu.transition.status', parentLabelId: 'reports' },
  '/category-change-report': { labelId: 'menu.category.change.report', parentLabelId: 'reports' },

  // Marketing
  '/marketing': { labelId: 'menu.marketing.broadcasts', parentLabelId: 'menu.marketing' },
  '/marketing/lists': { labelId: 'menu.marketing.recipients', parentLabelId: 'menu.marketing' },

  // 2Talk
  '/phoneregistrationrequests': { label: 'Solicitações de registro de provedor', parentLabelId: 'menu.2talk' },
  '/chat-attendance-list': { label: 'Conversas', parentLabelId: 'menu.2talk' },
  '/provider-groups': { labelId: 'menu.provider.groups', parentLabelId: 'menu.2talk' },
  '/chatclassifications': { labelId: 'menu.2talk.chatclassification', parentLabelId: 'menu.2talk' },
  '/channel': { labelId: 'menu.2talk.channel', parentLabelId: 'menu.2talk' },
  '/enableagents': { labelId: 'menu.2talk.enableagents', parentLabelId: 'menu.2talk' },
  '/rulesattendance': { labelId: 'menu.2talk.rulesattendance', parentLabelId: 'menu.2talk' },
  '/customers': { labelId: 'menu.2talk.customer', parentLabelId: 'menu.2talk' },
  '/companies': { labelId: 'menu.2talk.company', parentLabelId: 'menu.2talk' },
  '/webchats': { labelId: 'menu.2talk.webchat', parentLabelId: 'menu.2talk' },
  '/chatbots': { labelId: 'menu.2talk.chatbots', parentLabelId: 'menu.2talk' },
  '/quick-responses': { labelId: 'menu.2talk.quickresponses', parentLabelId: 'menu.2talk' },
  '/2talk-chat-report': { labelId: '2talk.chat.report', parentLabelId: 'menu.2talk' },
  '/2talk-satisfactionsurvey-report': { labelId: '2talk.satisfation.survey.report', parentLabelId: 'menu.2talk' },
  '/provider-predefined-message-templates': { label: 'Mensagens de modelo de provedor', parentLabelId: 'menu.2talk' },
  '/template-message': { labelId: 'templates', parentLabelId: 'menu.2talk' },

  // Central de ajuda
  '/faq-subject': { labelId: 'faq.subject', parentLabelId: 'user.guide' },
  '/knowledgebases': { labelId: 'knowledgebase', parentLabelId: 'user.guide' },
  '/faq': { labelId: 'faq', parentLabelId: 'user.guide' },
  '/faq-list-client': { labelId: 'faq', parentLabelId: 'user.guide' },
  '/feedbackarticles': { labelId: 'news.feedback', parentLabelId: 'user.guide' },
  '/articles': { labelId: 'news', parentLabelId: 'user.guide' },
  '/articles-client': { labelId: 'news', parentLabelId: 'user.guide' },
  '/articles-section': { labelId: 'news.section', parentLabelId: 'user.guide' },

  // Pausas
  '/break-work-collaborators-active': { labelId: 'menu.breakwork.collaborators.active', parentLabelId: 'menu.breakwork' },
  '/break-work-me': { labelId: 'menu.breakwork.me', parentLabelId: 'menu.breakwork' },
  '/break-reasons': { labelId: 'menu.reason.break', parentLabelId: 'menu.breakwork' },

  // Organizações
  '/organizationcategories': { labelId: 'menu.organization.categories', parentLabelId: 'menu.organizations' },
  '/calledlistdatas': { labelId: 'menu.calledlistdatas', parentLabelId: 'menu.organizations' },
  '/additional-service-config': { labelId: 'additional.called.cost.config', parentLabelId: 'menu.organizations' },
  '/called-report-configs': { labelId: 'called.report.configs', parentLabelId: 'menu.organizations' },
  '/organizationdepartaments': { labelId: 'menu.organizationdepartaments', parentLabelId: 'menu.organizations' },
  '/organizationmaterials': { labelId: 'menu.organizationmaterials', parentLabelId: 'menu.organizations' },
  '/organizations': { labelId: 'menu.organization', parentLabelId: 'menu.organizations' },
  '/organizationpatrimonies': { labelId: 'menu.organizationpatrimonies', parentLabelId: 'menu.organizations' },
  '/organizationslas': { labelId: 'menu.organization.sla', parentLabelId: 'menu.organizations' },

  // Acesso
  '/users': { labelId: 'menu.users-agents', parentLabelId: 'menu.access' },
  '/users-client': { labelId: 'menu.users-client', parentLabelId: 'menu.access' },
  '/permissions': { labelId: 'menu.permissions', parentLabelId: 'menu.access' },
  '/roles': { labelId: 'menu.roles', parentLabelId: 'menu.access' },

  // Grupos de atendimento
  '/techinicalteams': { labelId: 'menu.techinicalteams', parentLabelId: 'menu.servicegroup' },
  '/techinicalteamorganizationcategories': { labelId: 'menu.techinicalteamorganizationcategories', parentLabelId: 'menu.servicegroup' },
  '/techinicalteamorganizations': { labelId: 'menu.techinicalteamorganizations', parentLabelId: 'menu.servicegroup' },
  '/techinicalteamusers': { labelId: 'menu.techinicalteamusers', parentLabelId: 'menu.servicegroup' },

  // Integrações
  '/authentication': { labelId: 'authentication', parentLabelId: 'menu.integrations' },
  '/integration-service': { labelId: 'integration.service', parentLabelId: 'menu.integrations' },
  '/variable': { labelId: 'integration.user.variable.header', parentLabelId: 'menu.integrations' },
  '/params': { labelId: 'params', parentLabelId: 'menu.integrations' },
  '/webhooks': { labelId: 'menu.webhooks', parentLabelId: 'menu.integrations' },
  '/app-connectors': { labelId: 'menu.app.connectors', parentLabelId: 'menu.integrations' },
  '/voip-platforms': { labelId: 'menu.voip.platforms', parentLabelId: 'menu.integrations' },

  // IA
  '/llms': { labelId: 'submenu.llm', parentLabelId: 'menu.ia' },
  '/llm-events': { labelId: 'submenu.llm_events', parentLabelId: 'menu.ia' },

  // Automações
  '/automationv2': { labelId: 'automation', parentLabelId: 'menu.automations' },
  '/macro-list': { labelId: 'macro', parentLabelId: 'menu.automations' },

  // Configurações
  '/default-actions': { labelId: 'default.actions', parentLabelId: 'menu.configs' },
  '/task-templates': { label: 'Tarefas do chamado', parentLabelId: 'menu.configs' },
  '/activity-list': { labelId: 'menu.activities', parentLabelId: 'menu.configs' },
  '/alert-list': { labelId: 'menu.alerts', parentLabelId: 'menu.configs' },
  '/categories': { labelId: 'menu.categories', parentLabelId: 'menu.configs' },
  '/configs': { labelId: 'menu.configs', parentLabelId: 'menu.configs' },
  '/distributionstrategies': { labelId: 'menu.distributionstrategies', parentLabelId: 'menu.configs' },
  '/workhours': { labelId: 'menu.workhours', parentLabelId: 'menu.configs' },
  '/holidays': { labelId: 'menu.holiday', parentLabelId: 'menu.configs' },
  '/patrimonygroups': { labelId: 'menu.patrimonygroups', parentLabelId: 'menu.configs' },
  '/materials': { labelId: 'menu.materials', parentLabelId: 'menu.configs' },
  '/patrimonymaterials': { labelId: 'menu.patrimonymaterials', parentLabelId: 'menu.configs' },
  '/reasons': { labelId: 'reasons', parentLabelId: 'menu.configs' },
  '/originrequests': { labelId: 'menu.originrequests', parentLabelId: 'menu.configs' },
  '/client-portal': { labelId: 'client.portal', parentLabelId: 'menu.configs' },
  '/priorities': { labelId: 'priorities', parentLabelId: 'menu.configs' },
  '/satisfaction-survey-list': { labelId: 'satisfaction.survey', parentLabelId: 'menu.configs' },
  '/segments': { labelId: 'menu.segments', parentLabelId: 'menu.configs' },
  '/called-closing-statuses': { labelId: 'calledclosingstatus', parentLabelId: 'menu.configs' },
  '/slas': { labelId: 'menu.slas', parentLabelId: 'menu.configs' },
  '/statuses': { labelId: 'menu.statuses', parentLabelId: 'menu.configs' },
  '/patrimonysubgroups': { labelId: 'menu.patrimonysubgroups', parentLabelId: 'menu.configs' },
  '/types': { labelId: 'menu.called.types', parentLabelId: 'menu.configs' },
  '/slacounttypes': { labelId: 'menu.slacounttypes', parentLabelId: 'menu.configs' },
  '/units': { labelId: 'menu.units', parentLabelId: 'menu.configs' },
  '/tags-list': { labelId: 'menu.tags', parentLabelId: 'menu.configs' },
};
